import { store } from '../store'
import {
  SET_USER_PROFILE,
  SET_PROFILE_IMAGE,
  SET_LOGIN_DETAILS,
  SET_FEATURE_LIST,
} from '../utils/constants'
import * as CryptoJS from 'crypto-js'
import http from '../api/api'
import config from '../api/constants'
import Config from 'custom/config/environment'
import moment from 'moment'

const AES_SECRET_KEY = CryptoJS.enc.Utf8.parse(Config.NEO_KEY)
const encryptAES = (text) =>
  CryptoJS.AES.encrypt(text, AES_SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString()

const decryptAES = (text) =>
  CryptoJS.AES.decrypt(text, AES_SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
  })

const login = async (data) => {
  try {
    const encryptedPassword = await encryptAES(data?.password)
    const reqParams = {
      password: encryptedPassword,
      userName: data?.username,
      requestId: 'LOGIN',
      module: 'LOGIN',
    }
    const response = await http.post(config.apiRoute.LOGIN, reqParams, {})
    store.dispatch({ type: SET_LOGIN_DETAILS, payload: response.data })
    // store.dispatch({ type: SET_USERNAME, payload: response.data.userName })
    // const params = { requestId: 'GENERATEOTP' }
    // if (response.data.otpEnabled) {
    //   await http.post(config.apiRoute.LOGIN_OTP_GENERATE, params)
    //   return { otpEnable: true }
    // }
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const verifyOTP = async (data) => {
  try {
    const reqParams = {
      requestId: 'LOGIN',
      module: 'LOGIN',
      ...data,
    }
    const response = await http.post(config.apiRoute.LOGIN_OTP_VERIFY, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const logoutUser = async () => {
  try {
    const reqParams = {
      module: 'LOGIN',
      requestId: 'LOGOUT',
    }
    const response = await http.post(config.apiRoute.LOGOUT, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const forgotPasswordVerifyDetails = async (data) => {
  try {
    const formattedDOB = moment(data?.dob).format('YYYY-MM-DD')
    const reqParams = {
      srcAccount: data?.customerId,
      countryCode: data?.countryCode,
      mobileNo: data?.mobile,
      userName: data?.username,
      customerDob: formattedDOB,
      relationshipType: 'ACCOUNT',
      requestId: 'PASSWORDRESETVERIFY',
      module: data?.module,
    }
    const response = await http.post(config.apiRoute.RESET_PASSWORD_VERIFY, reqParams)
    // store.dispatch({ type: SET_CAPTCHA_CODE, payload: response.captchaCode })
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const updatePassword = async (data) => {
  try {
    const formattedDOB = moment(data?.dob).format('YYYY-MM-DD')
    const encryptedPassword = encryptAES(data?.password)
    const captcha = encryptAES(data?.captchaValue)
    const reqParams = {
      srcAccount: data?.customerId,
      mobileNo: data?.mobile,
      userName: data?.username,
      customerDob: formattedDOB,
      relationshipType: 'ACCOUNT',
      requestId: 'PASSWORDRESETVERIFY',
      module: '',
      otp: data?.otp,
      password: encryptedPassword,
      requestId: 'PASSWORDRESETCONFIRM', // ! new req id
    }
    const response = await http.post(config.apiRoute.RESET_PASSWORD_UPDATE, reqParams)
    // store.dispatch({ type: SET_CAPTCHA_CODE, payload: response.captchaCode })
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getUserProfile = async () => {
  try {
    const reqParams = {
      requestId: 'USERPROFILE',
    }
    const response = await http.post(config.apiRoute.GET_PROFILE_DETAILS, reqParams)
    store.dispatch({ type: SET_USER_PROFILE, payload: response.data.profileDetails })
    return response.data
  } catch (err) {
    throw err.response.data
  }
}
const verifyRegistration = async (data) => {
  try {
    const reqParams = {
      channelType: 'RETAILWEB',
      language: 'en',
      requestId: 'VERIFYACTIVELINK',
      ...data,
    }
    const response = await http.post(config.apiRoute.VERIFY_REGESTRATION, reqParams)
    return response.data.message
  } catch (err) {
    throw err.response.data.message
  }
}

const getUserProfileImage = async () => {
  try {
    const reqParams = {
      requestId: 'GETPROFILEIMAGE',
    }
    const response = await http.post(config.apiRoute.GET_PROFILE_IMAGE, reqParams)
    store.dispatch({ type: SET_PROFILE_IMAGE, payload: response.data['imageData'] })
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const updateUserProfileImage = async (imageData) => {
  try {
    const reqParams = {
      requestId: 'GETPROFILEIMAGE',
      imageData,
    }
    const response = await http.post(config.apiRoute.UPDATE_PROFILE_IMAGE, reqParams)
    store.dispatch({ type: SET_PROFILE_IMAGE, payload: imageData })
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const deleteUserProfileImage = async () => {
  try {
    const reqParams = {
      requestId: 'DELETEPROFILEIMAGE',
    }
    const response = await http.post(config.apiRoute.DELETE_PROFILE_IMAGE, reqParams)
    if (response.status === 200) {
      store.dispatch({ type: SET_PROFILE_IMAGE, payload: null })
    }
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const validateUsername = async ({ customerId, username }) => {
  try {
    const reqParams = {
      requestId: 'REGISTUSERVRFY',
    }
    const response = await http.post(config.apiRoute.VALIDATE_USERNAME, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const verifyUserDetails = async (data) => {
  try {
    const formattedDOB = moment(data?.dob).format('YYYY-MM-DD')
    const reqParams = {
      srcAccount: data?.customerId,
      userName: data?.username,
      mobileNo: data?.mobile,
      countryCode: data?.countryCode,
      customerDob: formattedDOB,
      relationshipType: 'ACCOUNT',
      uniqueIdType: data?.uniqueIdType,
      uniqueIdValue: data?.uniqueIdValue,
      requestId: 'REGISTUSERVRFY',
    }
    const response = await http.post(config.apiRoute.VERIFY_USER_DETAILS, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const verifyForgotUsername = async (data) => {
  try {
    const reqParams = {
      srcAccount: data?.srcAccount,
      mobileNo: data?.mobileNo,
      countryCode: data?.countryCode,
      customerDob: data?.customerDob,
      relationshipType: 'ACCOUNT',
      uniqueIdType: data?.uniqueIdType,
      uniqueIdValue: data?.uniqueIdValue,
      userName: data?.username,
      requestId: 'FORGOTUSERNAMEVERIFY',
      module: '',
    }
    const response = await http.post(config.apiRoute.VERIFY_FORGOT_USERNAME, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const verifyForgotUsernameConfirm = async (data) => {
  try {
    const reqParams = {
      srcAccount: data?.srcAccount,
      mobileNo: data?.mobileNo,
      countryCode: data?.countryCode,
      customerDob: data?.customerDob,
      relationshipType: 'ACCOUNT',
      uniqueIdType: data?.uniqueIdType,
      uniqueIdValue: data?.uniqueIdValue,
      userName: data?.username,
      otp: data?.otp,
      requestId: 'FORGOTUSERNAMECONFIRM',
      module: '',
    }
    const response = await http.post(config.apiRoute.VERIFY_FORGOT_USERNAME_CONFIRM, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getPasswordCriteria = async () => {
  try {
    const reqParams = {
      requestId: 'PWDCRITERIA',
    }
    const response = await http.post(config.apiRoute.GET_PASSWORD_CRITERIA, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const checkPasswordCriteria = async (data) => {
  try {
    const encryptedPassword = await encryptAES(data?.password)
    const reqParams = {
      requestId: 'REGISTUSERVRFY',
      haveUserName: 'N',
      password: encryptedPassword,
      randomKey: data?.randomKey,
    }
    const response = await http.post(config.apiRoute.CHECK_PASSWORD_CRITERIA, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const registerGenerateOTP = async (data) => {
  try {
    const reqParams = {
      accountNo: data?.customerId,
      relationshipType: 'Account No.',
      randomKey: data?.randomKey,
      requestId: 'GENERATEOTP',
      userName: data?.username,
    }
    const response = await http.post(config.apiRoute.REGISTER_GENERATE_OTP, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const registerUser = async (data) => {
  try {
    const encryptedPassword = await encryptAES(data?.password)
    const reqParams = {
      srcAccount: data?.customerId,
      mobileNo: data?.mobile,
      countryCode: data?.countryCode,
      customerDob: data?.dob,
      relationshipType: 'ACCOUNT',
      uniqueIdType: data?.uniqueIdType,
      uniqueIdValue: data?.uniqueIdValue,
      userName: data?.userName,
      requestId: 'REGISTUSERVRFY',
      otp: data?.otp,
      password: encryptedPassword,
    }
    const response = await http.post(config.apiRoute.REGISTER_USER, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getQRDecryptedInformation = async (text) => {
  const response = await decryptAES(text)
  return response.toString(CryptoJS.enc.Utf8)
}

const getOffers = async () => {
  try {
    const reqParams = {
      requestId: 'OFFERS',
      module: 'Information',
    }
    const response = await http.post(config.apiRoute.GET_OFFERS, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const checkCustByUniqueID = async (data) => {
  try {
    const reqParams = {
      requestId: 'CHECKCUSTBYUNIQUEID',
      uniqueId: data.identityType,
      uniqueVal: data.identityNumber,
      userName: 'DEFAULT',
    }
    const response = await http.post(config.apiRoute.CHECK_CUST_BY_UNIQUE_ID, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const featureCheck = async () => {
  try {
    const response = await http.post(config.apiRoute.featureCheck, {
      requestId: 'FEATURECHECK',
      module: 'FEATURE',
    })
    store.dispatch({ type: SET_FEATURE_LIST, payload: response.data['list'] || {} })
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getCountryCodes = async () => {
  try {
    const reqParams = {
      requestId: 'GETCOUNTRYCODES',
      module: '',
    }
    const response = await http.post(config.apiRoute.GET_ALL_COUNTRY_CODES, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const AuthService = {
  encryptAES,
  decryptAES,
  login,
  verifyOTP,
  logoutUser,
  forgotPasswordVerifyDetails,
  updatePassword,
  getUserProfile,
  verifyRegistration,
  getUserProfileImage,
  updateUserProfileImage,
  deleteUserProfileImage,
  validateUsername,
  verifyUserDetails,
  verifyForgotUsername,
  verifyForgotUsernameConfirm,
  getPasswordCriteria,
  checkPasswordCriteria,
  registerGenerateOTP,
  registerUser,
  getQRDecryptedInformation,
  getOffers,
  checkCustByUniqueID,
  featureCheck,
  getCountryCodes
}

export default AuthService
